"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration")),
    _queryString = _interopRequireDefault(require("query-string")),
    _clientAuth = require("@devsta/client-auth");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var IFRAME_ID = "download_iframe";

function _default(a) {
  var b = _reactGlobalConfiguration["default"].get("serviceEndpoint"),
      c = _clientAuth.credentials.get(),
      d = c.token,
      e = _objectSpread(_objectSpread({}, a), {}, {
    t: d
  }),
      f = "".concat(b, "export/downloads?").concat(_queryString["default"].stringify(e, {
    arrayFormat: "comma"
  })),
      g = document.getElementById(IFRAME_ID);

  if (g) return void (g.src = f);
  var h = document.createElement("iframe");
  h.setAttribute("id", IFRAME_ID), h.setAttribute("style", "display:none"), document.body.appendChild(h);
  var i = document.getElementById(IFRAME_ID);
  i && (i.src = f);
}